/* ============================================================
   AURELIA THEME — theme.js
   ============================================================ */
(function () {
  'use strict';

  const $ = (s, c = document) => c.querySelector(s);
  const $$ = (s, c = document) => Array.from(c.querySelectorAll(s));
  const money = (cents) => {
    return '₹' + (cents / 100).toLocaleString('en-IN', { minimumFractionDigits: 0, maximumFractionDigits: 2 });
  };

  /* ---------- Drawer open/close helpers ---------- */
  function openEl(el, overlay) {
    if (el) el.classList.add('is-open');
    if (overlay) overlay.classList.add('is-open');
    document.body.style.overflow = 'hidden';
  }
  function closeAll() {
    $$('.cart-drawer, .mobile-nav, .drawer-overlay').forEach((e) => e.classList.remove('is-open'));
    document.body.style.overflow = '';
  }

  document.addEventListener('click', (e) => {
    const t = e.target.closest('[data-drawer-close], .drawer-overlay');
    if (t) { closeAll(); }
  });
  document.addEventListener('keydown', (e) => { if (e.key === 'Escape') closeAll(); });

  /* ---------- Mobile nav ---------- */
  const menuToggle = $('.header__menu-toggle');
  if (menuToggle) {
    menuToggle.addEventListener('click', () => openEl($('.mobile-nav'), $('.drawer-overlay')));
  }

  /* ============================================================
     CART
     ============================================================ */
  const cartDrawer = $('.cart-drawer');

  async function refreshCart() {
    try {
      const res = await fetch(window.routes.cart_url + '?section_id=cart-drawer');
      const text = await res.text();
      const html = new DOMParser().parseFromString(text, 'text/html');
      const newInner = html.querySelector('.cart-drawer__inner');
      const cur = $('.cart-drawer__inner');
      if (newInner && cur) cur.innerHTML = newInner.innerHTML;
      const countEl = html.querySelector('[data-cart-count]');
      $$('[data-cart-count]').forEach((el) => {
        if (countEl) { el.textContent = countEl.textContent; el.hidden = countEl.textContent === '0'; }
      });
    } catch (err) { console.error(err); }
  }

  async function addToCart(form, openDrawer = true) {
    const btn = form.querySelector('[type="submit"]');
    const original = btn ? btn.textContent : '';
    if (btn) { btn.textContent = 'Adding...'; btn.disabled = true; }
    try {
      const formData = new FormData(form);
      formData.append('sections', 'cart-drawer');
      const res = await fetch(window.routes.cart_add_url, {
        method: 'POST',
        headers: { Accept: 'application/javascript' },
        body: formData
      });
      const data = await res.json();
      if (data.status) { alert(data.description || window.cartStrings.error); }
      else {
        await refreshCart();
        if (openDrawer && cartDrawer) openEl(cartDrawer, $('.drawer-overlay'));
      }
    } catch (err) {
      console.error(err);
      alert(window.cartStrings.error);
    } finally {
      if (btn) { btn.textContent = original; btn.disabled = false; }
    }
  }

  document.addEventListener('submit', (e) => {
    const form = e.target.closest('form[action*="/cart/add"], form[data-ajax-cart]');
    if (form) { e.preventDefault(); addToCart(form); }
  });

  // Open cart drawer on cart icon click (if drawer exists)
  $$('[data-cart-toggle]').forEach((el) => {
    el.addEventListener('click', (e) => {
      if (cartDrawer) { e.preventDefault(); refreshCart().then(() => openEl(cartDrawer, $('.drawer-overlay'))); }
    });
  });

  // Quantity change / remove inside drawer
  document.addEventListener('click', async (e) => {
    const qtyBtn = e.target.closest('[data-qty-change]');
    const removeBtn = e.target.closest('[data-cart-remove]');
    if (!qtyBtn && !removeBtn) return;
    e.preventDefault();
    let line, qty;
    if (qtyBtn) {
      line = qtyBtn.dataset.line;
      qty = parseInt(qtyBtn.dataset.qty, 10);
    } else {
      line = removeBtn.dataset.line;
      qty = 0;
    }
    await fetch(window.routes.cart_change_url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ line: parseInt(line, 10), quantity: qty })
    });
    await refreshCart();
  });

  /* ============================================================
     PRODUCT PAGE
     ============================================================ */
  // Product gallery: swipe + auto-slide + thumbs + dots + zoom lightbox
  (function productGallery() {
    const gallery = $('[data-gallery]');
    if (!gallery) return;
    const track = $('[data-gallery-track]', gallery);
    const slides = $$('[data-gallery-slide]', track);
    const thumbs = $$('[data-product-thumbs] button');
    const dots = $$('[data-gallery-dots] [data-dot]');
    const prevBtn = $('[data-gallery-prev]', gallery);
    const nextBtn = $('[data-gallery-next]', gallery);
    let current = 0;
    let timer = null;
    const autoplay = gallery.dataset.autoplay === 'true' && slides.length > 1;
    const speed = (parseInt(gallery.dataset.speed, 10) || 4) * 1000;

    function setActive(i) {
      current = i;
      thumbs.forEach((t, idx) => t.classList.toggle('is-active', idx === i));
      dots.forEach((d, idx) => d.classList.toggle('is-active', idx === i));
    }
    function goTo(i, smooth) {
      if (!slides.length) return;
      i = (i + slides.length) % slides.length;
      track.scrollTo({ left: slides[i].offsetLeft, behavior: smooth === false ? 'auto' : 'smooth' });
      setActive(i);
    }

    // keep dots/thumbs in sync while the user swipes
    let raf;
    track.addEventListener('scroll', () => {
      cancelAnimationFrame(raf);
      raf = requestAnimationFrame(() => {
        const i = Math.round(track.scrollLeft / track.clientWidth);
        if (i !== current && slides[i]) setActive(i);
      });
    }, { passive: true });

    thumbs.forEach((t) => t.addEventListener('click', () => { stop(); goTo(parseInt(t.dataset.index, 10)); }));
    dots.forEach((d) => d.addEventListener('click', () => { stop(); goTo(parseInt(d.dataset.dot, 10)); }));
    if (prevBtn) prevBtn.addEventListener('click', () => { stop(); goTo(current - 1); });
    if (nextBtn) nextBtn.addEventListener('click', () => { stop(); goTo(current + 1); });

    // auto-slide (pauses on interaction / hidden tab)
    function start() { if (!autoplay) return; stop(); timer = setInterval(() => goTo(current + 1), speed); }
    function stop() { if (timer) { clearInterval(timer); timer = null; } }
    ['pointerdown', 'touchstart', 'mouseenter', 'focusin'].forEach((ev) =>
      gallery.addEventListener(ev, stop, { passive: true }));
    gallery.addEventListener('mouseleave', start);
    document.addEventListener('visibilitychange', () => (document.hidden ? stop() : start()));
    start();

    // let variant selection jump the gallery to that colour's image
    window.galleryShowMedia = function (mediaId) {
      const idx = slides.findIndex((s) => String(s.dataset.mediaId) === String(mediaId));
      if (idx >= 0) { stop(); goTo(idx); }
    };

    /* ---- Full-screen zoom lightbox (tap a slide; pinch on mobile, click-zoom on desktop) ---- */
    const zoomSrcs = slides.map((s) => s.dataset.zoom).filter(Boolean);
    if (!zoomSrcs.length) return;
    const lb = document.createElement('div');
    lb.className = 'zoom-lightbox';
    lb.innerHTML =
      '<button class="zoom-lightbox__close" aria-label="Close">✕</button>' +
      (zoomSrcs.length > 1 ? '<button class="zoom-lightbox__nav zoom-lightbox__nav--prev"></button><button class="zoom-lightbox__nav zoom-lightbox__nav--next"></button>' : '') +
      '<div class="zoom-lightbox__stage"><img class="zoom-lightbox__img" alt=""></div>' +
      (zoomSrcs.length > 1 ? '<div class="zoom-lightbox__count"></div>' : '');
    document.body.appendChild(lb);
    const lbImg = $('.zoom-lightbox__img', lb);
    const countEl = $('.zoom-lightbox__count', lb);
    const caret = '<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7"><path d="M6 9l6 6 6-6"/></svg>';
    $$('.zoom-lightbox__nav', lb).forEach((n) => (n.innerHTML = caret));
    let zi = 0;
    function lbRender() {
      lbImg.src = zoomSrcs[zi];
      lbImg.classList.remove('is-zoomed'); lbImg.style.transform = '';
      if (countEl) countEl.textContent = (zi + 1) + ' / ' + zoomSrcs.length;
    }
    function lbOpen(i) { zi = i || 0; lbRender(); lb.classList.add('is-open'); document.body.style.overflow = 'hidden'; }
    function lbClose() { lb.classList.remove('is-open'); document.body.style.overflow = ''; }
    function lbMove(d) { zi = (zi + d + zoomSrcs.length) % zoomSrcs.length; lbRender(); }

    slides.forEach((s, i) => s.addEventListener('click', () => lbOpen(i)));
    lb.addEventListener('click', (e) => {
      if (e.target.closest('.zoom-lightbox__close')) return lbClose();
      if (e.target.closest('.zoom-lightbox__nav--prev')) return lbMove(-1);
      if (e.target.closest('.zoom-lightbox__nav--next')) return lbMove(1);
      if (e.target === lb || e.target.classList.contains('zoom-lightbox__stage')) return lbClose();
      if (e.target === lbImg) {
        const z = lbImg.classList.toggle('is-zoomed');
        lbImg.style.transform = z ? 'scale(2)' : '';
      }
    });
    document.addEventListener('keydown', (e) => {
      if (!lb.classList.contains('is-open')) return;
      if (e.key === 'Escape') lbClose();
      if (e.key === 'ArrowLeft') lbMove(-1);
      if (e.key === 'ArrowRight') lbMove(1);
    });
  })();

  // Quantity stepper
  $$('.qty-selector').forEach((sel) => {
    const input = $('input', sel);
    sel.addEventListener('click', (e) => {
      const b = e.target.closest('button');
      if (!b || !input) return;
      let v = parseInt(input.value, 10) || 1;
      v = b.dataset.dir === 'up' ? v + 1 : Math.max(1, v - 1);
      input.value = v;
    });
  });

  // Variant selection -> update price / image / availability / sticky bar
  (function initVariants() {
    const wrap = $('[data-variant-radios]');
    const variantsScript = $('[data-variants-json]');
    if (!variantsScript) return;
    const variants = JSON.parse(variantsScript.textContent);
    const idInput = $('[data-variant-id]');
    const priceEl = $('[data-price]');
    const compareEl = $('[data-compare-price]');
    const discountEl = $('[data-discount]');
    const submitBtn = $('[data-add-btn]');
    const mainImg = $('[data-product-main-img]');
    const stickyPrice = $('[data-sticky-price]');
    const stickyCompare = $('[data-sticky-compare]');
    const stickySave = $('[data-sticky-save]');

    function selected() {
      if (!wrap) return variants.find((v) => v.id == (idInput && idInput.value)) || variants[0];
      const opts = $$('[data-variant-radios] input:checked').map((i) => i.value);
      return variants.find((v) => v.options.every((o, idx) => o === opts[idx]));
    }
    function update() {
      const v = selected();
      if (!v) return;
      if (idInput) idInput.value = v.id;
      if (priceEl) priceEl.textContent = money(v.price);
      if (stickyPrice) stickyPrice.textContent = money(v.price);
      const onSale = v.compare_at_price && v.compare_at_price > v.price;
      const pctOff = onSale ? Math.round((1 - v.price / v.compare_at_price) * 100) : 0;
      if (compareEl) compareEl.textContent = onSale ? money(v.compare_at_price) : '';
      if (discountEl) discountEl.textContent = onSale ? pctOff + '% OFF' : '';
      if (stickyCompare) stickyCompare.textContent = onSale ? money(v.compare_at_price) : '';
      if (stickySave) {
        if (onSale) { stickySave.textContent = 'SAVE ' + pctOff + '%'; stickySave.hidden = false; }
        else stickySave.hidden = true;
      }
      // selected-value labels
      $$('[data-selected-for]').forEach((el) => {
        const pos = parseInt(el.dataset.selectedFor, 10);
        el.textContent = v.options[pos - 1];
      });
      // jump gallery to the variant's image
      if (v.featured_image && v.featured_image.id && typeof window.galleryShowMedia === 'function') {
        window.galleryShowMedia(v.featured_image.id);
      }
      const stickyBtn = $('[data-sticky-btn]');
      if (stickyBtn) stickyBtn.disabled = !v.available;
      if (submitBtn) {
        submitBtn.disabled = !v.available;
        submitBtn.textContent = v.available ? submitBtn.dataset.label : 'Sold out';
      }
      // low-stock urgency bar (skip if the simulator is running; only act when inventory known)
      const urgency = $('[data-stock-urgency]');
      if (urgency && urgency.dataset.simulate !== 'true' && typeof v.inventory_quantity === 'number') {
        const threshold = parseInt(urgency.dataset.threshold, 10) || 15;
        const q = v.inventory_quantity;
        if (q > 0 && q <= threshold) {
          urgency.hidden = false;
          const qtyEl = $('[data-stock-qty]', urgency);
          const fill = $('[data-stock-fill]', urgency);
          if (qtyEl) qtyEl.textContent = q;
          if (fill) fill.style.width = Math.max(8, Math.round((q / threshold) * 100)) + '%';
        } else {
          urgency.hidden = true;
        }
      }
    }
    if (wrap) wrap.addEventListener('change', update);
    update();
  })();

  /* ---------- Sticky add-to-cart bar (mobile) ---------- */
  (function stickyAtc() {
    const bar = $('[data-sticky-atc]');
    const anchor = $('[data-add-btn]');
    if (!bar || !anchor) return;
    document.body.classList.add('has-sticky-atc');
    const io = new IntersectionObserver((entries) => {
      bar.classList.toggle('is-visible', !entries[0].isIntersecting);
    }, { rootMargin: '0px 0px -80px 0px' });
    io.observe(anchor);
  })();

  /* ---------- Auto-rotating stock urgency counter ---------- */
  (function stockSimulator() {
    const el = $('[data-stock-urgency]');
    if (!el || el.dataset.simulate !== 'true') return;
    const rnd = (a, b) => Math.floor(Math.random() * (b - a + 1)) + a;
    const min = parseInt(el.dataset.simMin, 10) || 5;
    const max = parseInt(el.dataset.simMax, 10) || 12;
    const floor = parseInt(el.dataset.simFloor, 10) || 2;
    const threshold = parseInt(el.dataset.threshold, 10) || 15;
    const interval = (parseInt(el.dataset.simInterval, 10) || 8) * 1000;
    const qtyEl = $('[data-stock-qty]', el);
    const fill = $('[data-stock-fill]', el);
    let count = rnd(min, max);

    function paint() {
      if (qtyEl) {
        qtyEl.textContent = count;
        if (qtyEl.animate) qtyEl.animate(
          [{ transform: 'scale(1.35)' }, { transform: 'scale(1)' }],
          { duration: 320, easing: 'ease-out' }
        );
      }
      if (fill) fill.style.width = Math.max(6, Math.min(100, Math.round((count / threshold) * 100))) + '%';
    }
    paint();
    (function tick() {
      setTimeout(() => {
        count -= 1;
        if (count < floor) count = rnd(Math.max(floor + 3, min), max); // rotate back up
        paint();
        tick();
      }, interval + rnd(0, 3000));
    })();
  })();

  /* ---------- Product carousel arrows ---------- */
  $$('.carousel-wrap').forEach((wrap) => {
    const track = $('.carousel', wrap);
    const step = () => Math.max(200, track.clientWidth * 0.8);
    const prev = $('[data-carousel-prev]', wrap);
    const next = $('[data-carousel-next]', wrap);
    if (prev) prev.addEventListener('click', () => track.scrollBy({ left: -step(), behavior: 'smooth' }));
    if (next) next.addEventListener('click', () => track.scrollBy({ left: step(), behavior: 'smooth' }));
  });

  /* ---------- Shopify product recommendations ---------- */
  $$('[data-recommendations]').forEach(async (sec) => {
    const track = $('.carousel', sec);
    const id = sec.dataset.productId;
    const limit = sec.dataset.limit || 10;
    if (!track || !id) return;
    try {
      const res = await fetch(`/recommendations/products?section_id=product-carousel&product_id=${id}&limit=${limit}`);
      const text = await res.text();
      const doc = new DOMParser().parseFromString(text, 'text/html');
      const fresh = doc.querySelector('.carousel');
      if (fresh && fresh.children.length) track.innerHTML = fresh.innerHTML;
    } catch (e) { /* keep fallback */ }
  });

  /* ---------- Complete Your Look bundle ---------- */
  $$('[data-bundle]').forEach((bundle) => {
    const baseEl = $('[data-bundle-add]', bundle);
    const totalEl = $('[data-bundle-total]', bundle);
    const basePrice = totalEl ? (parseInt(totalEl.dataset.basePrice, 10) || 0) : 0;

    function recalc() {
      let total = basePrice;
      $$('[data-bundle-item]:checked', bundle).forEach((c) => { total += parseInt(c.dataset.price, 10) || 0; });
      if (totalEl) totalEl.textContent = money(total);
    }
    bundle.addEventListener('change', recalc);
    recalc();

    if (baseEl) baseEl.addEventListener('click', async () => {
      const items = [{ id: baseEl.dataset.baseVariant, quantity: 1 }];
      $$('[data-bundle-item]:checked', bundle).forEach((c) => items.push({ id: c.dataset.variant, quantity: 1 }));
      baseEl.disabled = true; baseEl.textContent = 'Adding...';
      try {
        const res = await fetch(window.routes.cart_add_url, {
          method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items })
        });
        if (res.ok) {
          const drawer = $('.cart-drawer');
          if (drawer) {
            const r = await fetch(window.routes.cart_url + '?section_id=cart-drawer');
            const html = new DOMParser().parseFromString(await r.text(), 'text/html');
            const inner = html.querySelector('.cart-drawer__inner');
            if (inner) $('.cart-drawer__inner').innerHTML = inner.innerHTML;
            drawer.classList.add('is-open'); $('.drawer-overlay').classList.add('is-open');
            document.body.style.overflow = 'hidden';
          } else { window.location.href = window.routes.cart_url; }
        }
      } finally { baseEl.disabled = false; baseEl.textContent = 'Add bundle to cart'; }
    });
  });

  /* ============================================================
     COLLECTION SORTING
     ============================================================ */
  $$('[data-sort-select]').forEach((sel) => {
    sel.addEventListener('change', () => {
      const url = new URL(window.location.href);
      url.searchParams.set('sort_by', sel.value);
      window.location.href = url.toString();
    });
  });

  /* ============================================================
     UGC autoplay on hover (desktop)
     ============================================================ */
  $$('.ugc-card video').forEach((v) => {
    const card = v.closest('.ugc-card');
    card.addEventListener('mouseenter', () => v.play().catch(() => {}));
    card.addEventListener('mouseleave', () => { v.pause(); v.currentTime = 0; });
  });

  /* ============================================================
     MODALS (size guide, etc.)
     ============================================================ */
  function closeModal(overlay) {
    if (!overlay) return;
    overlay.classList.remove('is-open');
    document.body.style.overflow = '';
    const vid = overlay.querySelector('video');
    if (vid) vid.pause();
  }
  document.addEventListener('click', (e) => {
    const trigger = e.target.closest('[data-modal-open]');
    if (trigger) {
      const overlay = $('[data-modal="' + trigger.dataset.modalOpen + '"]');
      if (overlay) { overlay.classList.add('is-open'); document.body.style.overflow = 'hidden'; }
      return;
    }
    const close = e.target.closest('[data-modal-close]');
    if (close) { closeModal(close.closest('.modal-overlay')); return; }
    if (e.target.classList.contains('modal-overlay')) closeModal(e.target);
  });
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') $$('.modal-overlay.is-open').forEach(closeModal);
  });

  /* ============================================================
     PROMO POPUP (auto-open on load)
     ============================================================ */
  (function promoPopup() {
    const pop = $('[data-promo-popup]');
    if (!pop) return;
    const freq = pop.dataset.frequency || 'always';
    const delay = (parseInt(pop.dataset.delay, 10) || 0) * 1000;
    const KEY = 'kaavri_promo_popup';

    function alreadySeen() {
      try {
        if (freq === 'session') return sessionStorage.getItem(KEY) === '1';
        if (freq === 'daily') {
          const t = parseInt(localStorage.getItem(KEY), 10);
          return t && Date.now() - t < 86400000;
        }
      } catch (e) {}
      return false; // 'always'
    }
    function remember() {
      try {
        if (freq === 'session') sessionStorage.setItem(KEY, '1');
        if (freq === 'daily') localStorage.setItem(KEY, String(Date.now()));
      } catch (e) {}
    }
    function close() {
      pop.classList.remove('is-open');
      document.body.style.overflow = '';
      remember();
    }
    if (alreadySeen()) return;
    setTimeout(() => {
      pop.classList.add('is-open');
      document.body.style.overflow = 'hidden';
    }, delay);
    pop.addEventListener('click', (e) => {
      if (e.target.closest('[data-promo-close]') || e.target === pop) { e.preventDefault(); close(); }
    });
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && pop.classList.contains('is-open')) close();
    });
  })();

  /* ============================================================
     UGC REVIEW LIGHTBOX
     ============================================================ */
  (function ugcLightbox() {
    const tiles = $$('[data-ugc]');
    if (!tiles.length) return;
    // build a shared lightbox once
    const overlay = document.createElement('div');
    overlay.className = 'modal-overlay';
    overlay.setAttribute('data-modal', 'ugc-lightbox');
    overlay.innerHTML = '<div class="modal modal--media"><button class="modal__close" data-modal-close aria-label="Close">✕</button><div data-ugc-stage></div><div class="modal__caption" data-ugc-caption></div></div>';
    document.body.appendChild(overlay);
    const stage = $('[data-ugc-stage]', overlay);
    const caption = $('[data-ugc-caption]', overlay);

    tiles.forEach((tile) => {
      tile.addEventListener('click', () => {
        const type = tile.dataset.type;
        const src = tile.dataset.src;
        stage.innerHTML = type === 'video'
          ? '<video src="' + src + '" controls autoplay playsinline></video>'
          : '<img src="' + src + '" alt="">';
        caption.textContent = tile.dataset.caption || '';
        overlay.classList.add('is-open');
        document.body.style.overflow = 'hidden';
      });
    });
  })();
})();
